import React from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsAppButton = () => {
  const phoneNumber = "12265826067"; // country code + number
  const message = encodeURIComponent(
    "Hi, I would like to know more about Art of Living programs."
  );

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      className="floating-social-link floating-social-link--whatsapp"
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        backgroundColor: "#25D366",
        color: "white",
      }}
    >
      <WhatsAppIcon style={{ fontSize: 35 }} />
    </a>
  );
};

export default WhatsAppButton;
